import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getFrasesConfirmacionService,
  createMultipleFrasesConfirmacionService,
  getFraseConfirmacionByIdService,
  updateFraseConfirmacionService,
  toggleFraseConfirmacionActiveService,
} from "../../../services/frasesConfirmacion/frasesConfirmacion.service";

export const getFrasesConfirmacionThunk = createAsyncThunk(
  "frasesConfirmacion/getAll",
  async ({ page = 1, search = "", talento = "", pregunta = "" } = {}, { rejectWithValue }) => {
    try {
      return await getFrasesConfirmacionService(page, search, talento, pregunta);
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue("Página no válida");
      }
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener frases";

      return rejectWithValue(message);
    }
  },
);

export const createMultipleFrasesConfirmacionThunk = createAsyncThunk(
  "frasesConfirmacion/createMultiple",
  async (payload, { rejectWithValue }) => {
    try {
      return await createMultipleFrasesConfirmacionService(payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al crear frases";

      return rejectWithValue(message);
    }
  },
);

export const getFraseConfirmacionByIdThunk = createAsyncThunk(
  "frasesConfirmacion/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getFraseConfirmacionByIdService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener frase";

      return rejectWithValue(message);
    }
  },
);

export const updateFraseConfirmacionThunk = createAsyncThunk(
  "frasesConfirmacion/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updateFraseConfirmacionService(id, payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al actualizar frase";

      return rejectWithValue(message);
    }
  },
);

export const toggleFraseConfirmacionActiveThunk = createAsyncThunk(
  "frasesConfirmacion/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await toggleFraseConfirmacionActiveService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al cambiar estado";

      return rejectWithValue(message);
    }
  },
);
